/**
 * Streaming state reported to Firefly's Device Media Concurrency Service
 * (DMCS). PLAYING acquires a stream slot; PAUSED / STOPPED release it.
 */
export enum DevicePlaybackConcurrencyState {
    PLAYING = 'PLAYING',
    PAUSED = 'PAUSED',
    STOPPED = 'STOPPED',
}

/**
 * Firefly surfaces a max-concurrency violation as a GraphQL error whose
 * `extensions.code` is `UPDATE_STREAMING_STATUS_ERROR` and whose
 * `extensions.payload.statusCode` is `MAX_CONCURRENCY_REACHED` — not as a
 * field on the mutation response. Mirrors hornet's `FireFlyConcurrencyErrorCode`.
 */
export enum FireFlyConcurrencyErrorCode {
    MAX_CONCURRENCY_REACHED = 'MAX_CONCURRENCY_REACHED',
    UPDATE_STREAMING_STATUS_ERROR = 'UPDATE_STREAMING_STATUS_ERROR',
}
